import axios, { AxiosResponse } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import getAPIUrl from '../config';
import getLocalStorageData, { clearLocalStorage, getAccessToken, setAccessToken } from './token';

// use this for calling public apis
export const axiosInstance = axios.create({
    baseURL: getAPIUrl(),
    headers: {
        'content-type': 'application/json',
    },
    responseType: 'json',
});
// use this for calling apis which need authentication
export const axiosInstanceWithAuth = axios.create({
    baseURL: getAPIUrl(),
    headers: {
        'content-type': 'application/json',
    },
    responseType: 'json',
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const refreshAuthLogic = (failedRequest: any) => {
    const { email, id, refreshToken } = getLocalStorageData();
    return axiosInstance
        .post(`${getAPIUrl()}/admins/refresh-token`, { email, id: Number(id), refreshToken })
        .then((res: AxiosResponse<{ data: { accessToken: string } }>) => {
            setAccessToken(res.data.data.accessToken);
            // eslint-disable-next-line no-param-reassign
            failedRequest.response.config.headers.Authorization = `Bearer ${res.data.data.accessToken}`;
            return Promise.resolve();
        })
        .catch((error) => {
            clearLocalStorage();
            return Promise.reject(error);
        });
};
axiosInstanceWithAuth.interceptors.request.use((request) => {
    const accToken = getAccessToken();
    if (accToken) {
        if (request.headers) {
            request.headers.Authorization = `Bearer ${accToken ?? ''}`;
        } else {
            request.headers = { Authorization: `Bearer ${accToken ?? ''}` };
        }
    }
    return request;
});

createAuthRefreshInterceptor(axiosInstanceWithAuth, refreshAuthLogic, {
    statusCodes: [401],
});

export default axiosInstance;
